import { render, staticRenderFns } from "./EcommerceTransactions.vue?vue&type=template&id=515c9df0"
import script from "./EcommerceTransactions.vue?vue&type=script&lang=js"
export * from "./EcommerceTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports